import { OrangePreset } from './orange.preset';

// Central registry of visual-theme presets. PR1 only ships `orange`
// (the single theme currently compiled into the build — see
// BASELINE.md). PR2 decides the fate of the 7 orphan theme-*.scss
// files in src/assets/themes/ and extends this map accordingly.
//
// The preset objects are typed by the return type of definePreset() from
// @primeng/themes — the library does not export a standalone `Preset` type,
// so we let TypeScript infer.

export type ThemeName = 'orange';

export const PRESET_MAP = {
  orange: OrangePreset,
} satisfies Record<ThemeName, typeof OrangePreset>;

export const DEFAULT_PRESET = OrangePreset;
